import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import {
  BELEG,
  BILD_BREITE,
  BILD_HOEHE,
  HAKEN_PFAD,
  KAESTCHEN,
  KOPF_STRICHE,
  KOPF_TEXTE,
  POSITIONEN,
  Position,
  RAHMEN,
  STEMPEL,
  SUMME
} from './belegGeometrie';

/**
 * Startbild «Beleglauf» des AB/RE-Portals.
 *
 * Ablauf in zwei Sätzen: Auf dem Navy-Raster zeichnet sich ein Beleg als
 * Formular - Kopf, Positionszeilen, Summenblock. Ein Scan legt von links das
 * Foto frei, die geprüften Zeilen rasten der Reihe nach ein, eine bleibt
 * bernsteinfarben offen, und der Stempel setzt sich auf den Summenblock.
 *
 * ⚠️ Das Startbild kostet keine Sekunde: Es liegt ÜBER der Anwendung, die
 * darunter von der ersten Zeile an lädt. Weggenommen wird es von
 * `AppComponent`, sobald der Ablauf einmal durch ist UND die Seite darunter
 * gemeldet hat, dass sie steht (siehe `SplashReadyService`).
 *
 * Alles ist CSS-Animation, kein Zeitgeber: ein Durchlauf steht nach rund 2.8 s
 * und driftet danach ruhig weiter, bis das Ausblenden kommt.
 *
 * ⚠️ `@keyframes` sind in Angular 14 NICHT gekapselt (das kam erst mit 15) -
 * jeder Name trägt deshalb das Präfix `ab-`.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-startbild',
  templateUrl: './startbild.component.html',
  styleUrls: ['./startbild.component.css']
})
export class StartbildComponent implements OnInit {
  /** Ablauf stauchen (< 1) oder dehnen (> 1). */
  @Input() tempo = 1;

  /** Weich ausblenden; die Seite darunter ist ab sofort bedienbar. */
  @Input() @HostBinding('class.ab-aus') ausblenden = false;

  public readonly ansicht = `0 0 ${BILD_BREITE} ${BILD_HOEHE}`;
  public readonly rahmen = RAHMEN;
  public readonly beleg = BELEG;
  public readonly kopfStriche = KOPF_STRICHE;
  public readonly kopfTexte = KOPF_TEXTE;
  public readonly positionen = POSITIONEN;
  public readonly kaestchen = KAESTCHEN;
  public readonly hakenPfad = HAKEN_PFAD;
  public readonly summe = SUMME;
  public readonly stempel = STEMPEL;

  /** Die fünf Schritte des Werkzeugs - der echte Ablauf, keine Allgemeinplätze. */
  public readonly schritte = [
    'Bestellung',
    'Beleg',
    'Prüfung',
    'Freigabe',
    'Abacus'
  ];

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Verlässlicher als eine Stilbindung auf eine eigene Eigenschaft: In
    // Angular 14 ist `[style.--tempo]` nicht zugesichert.
    this.elementRef.nativeElement.style.setProperty('--tempo', String(this.tempo));
  }

  /** Waagrechte Mitte des Kästchens einer Zeile. */
  public kaestchenY(position: Position): number {
    return position.y - this.kaestchen.groesse / 2;
  }
}
